import { getEmployees } from "./employees";
import { photoUrlOrNull, type EmployeeIdentity } from "../utils/people/peopleDirectory";

// `/employeesAll` caps `limit` at 100 and pages with `offset`; the server
// scopes it by role (admin: branch, manager: reports, employee: self).
const PAGE_SIZE = 100;
const MAX_PAGES = 10;

function text(value: unknown): string | null {
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  if (typeof value !== "string") return null;
  return value.trim() || null;
}

function toIdentity(row: unknown): EmployeeIdentity | null {
  if (!row || typeof row !== "object") return null;
  const item = row as Record<string, unknown>;
  const employeeId = text(item.id) ?? text(item.emptID) ?? text(item.employee_id);
  if (!employeeId) return null;
  return {
    employeeCode: text(item.employeeID) ?? text(item.employee_code),
    employeeId,
    photoUrl: photoUrlOrNull(item.profile_photo_url),
    userId: text(item.user_id),
  };
}

/** The page's faces: user_id / Employee.id / employee code → photo. One call. */
export async function fetchEmployeeIdentities(): Promise<EmployeeIdentity[]> {
  const identities: EmployeeIdentity[] = [];
  for (let page = 0; page < MAX_PAGES; page += 1) {
    const data = await getEmployees({ limit: PAGE_SIZE, offset: page * PAGE_SIZE });
    const rows: unknown[] = Array.isArray((data as any)?.employees)
      ? (data as any).employees
      : Array.isArray(data) ? (data as any) : [];
    for (const row of rows) {
      const identity = toIdentity(row);
      if (identity) identities.push(identity);
    }
    const total = typeof (data as any)?.total === "number" ? (data as any).total : Number.NaN;
    if (rows.length < PAGE_SIZE || (Number.isFinite(total) && (page + 1) * PAGE_SIZE >= total)) break;
  }
  return identities;
}
